export default "__VITE_ASSET__DfQp$SwK__"